import { wxLogin, wxMyInfo } from '@/utils/request'
import { getOpenid, removeOpenid, setOpenid } from '@/utils/cookie'

const state = {
  openid: getOpenid(),
  userInfo: {}
}

const mutations = {
  SET_OPENID: (state, openid) => {
    state.openid = openid
    if (openid) {
      setOpenid(openid)
    } else {
      removeOpenid()
    }
  }
}

const actions = {
  wxLogin ({ commit }, code) {
    return new Promise((resolve, reject) => {
      wxLogin(code).then(response => {
        response.data = JSON.parse(response.data)
        commit('SET_OPENID', response.data.openid)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  wxLogout ({ commit, state }) {
    commit('SET_OPENID', undefined)
    state.userInfo = {}
  },
  setOpenid ({ commit }, openid) {
    commit('SET_OPENID', openid)
    return new Promise((resolve, reject) => {
      wxMyInfo().then(response => {
        state.userInfo = response.data
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
